import React, { useMemo } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/internationalMinutesTableStyle';
import { makeStyles, useTheme } from '@material-ui/core';
import ServicePicker from 'components/ServicePicker';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import InternationalMinutesColumn from './columns/InternationalMinutesColumn';
import { INCLUDED_MINUTES } from './constants';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IInternationalMinutesTableProps {
	selectedTab: number | null;
	setSelectedTab: React.Dispatch<React.SetStateAction<number | null>>;
	catalogEntryView: types.ecommerce.CatalogEntryView[];
}

const InternationalMinutesTable = ({
	selectedTab,
	setSelectedTab,
	catalogEntryView,
}: IInternationalMinutesTableProps) => {
	const classes = useStyles();
	const theme = useTheme();
	const xsDown = useMediaQuery(theme.breakpoints.down('xs'));
	const smDown = useMediaQuery(theme.breakpoints.down('sm'));

	const sortCatalog = (a: types.ecommerce.CatalogEntryView, b: types.ecommerce.CatalogEntryView) => {
		const aMinutes = a.attributes.find((attr) => attr.identifier === INCLUDED_MINUTES).values[0].value;
		const bMinutes = b.attributes.find((attr) => attr.identifier === INCLUDED_MINUTES).values[0].value;
		return +aMinutes - +bMinutes;
	};

	const tabs = useMemo(() => {
		const sortedCatalogEntryView = catalogEntryView.sort(sortCatalog);
		return sortedCatalogEntryView.map((singleCatalogEntryView) => {
			// const attributes = singleCatalogEntryView.attributes;
			return {
				column: <InternationalMinutesColumn catalogEntryView={singleCatalogEntryView} />,
				numberOfCells: 2,
				header: {
					title: singleCatalogEntryView.name,
					height: 170,
				},
			};
		});
	}, [catalogEntryView]);

	return (
		<div className={classes.internationalMinutesTableWrapper}>
			<ServicePicker
				selectedTab={selectedTab}
				setSelectedTab={setSelectedTab}
				tabs={tabs}
				numberOfTabsOnSlide={xsDown ? 1 : smDown ? 3 : tabs.length}
				selectedTabColor="primary"
			/>
		</div>
	);
};

export default InternationalMinutesTable;
